export default __webpack_public_path__ + "static/media/chat-icon.7f42811c.svg";